import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhadapsar() {



  const cardData =
  {
    keyword: 'Corporate Cab Service in Hadapsar',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Hadapsar',
    headingDescription: ' Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Hadapsar, tailored to meet the travel needs of IT parks, business centers, and corporate offices in the area. Our fleet of executive sedans, SUVs, and premium cars ensures smooth and comfortable transportation for employees, clients, and top-level executives. Whether it is daily office commute, airport transfers, client meetings, or VIP travel, we deliver punctual, safe, and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium corporate travel experience for businesses operating in and around Hadapsar.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



 "services": [
  {
    "name": "Hadapsar IT Park Cab Service",
    "description": "Hadapsar IT Park Cab Service provides fast, reliable, and professional office commute solutions for employees working in Hadapsar’s IT hubs. With punctual pickups, route-optimized travel, and trained chauffeurs, we ensure a smooth experience during peak office hours and shift timings. Our fleet includes AC sedans, SUVs, and hatchbacks that are regularly serviced and sanitized. Hadapsar IT Park Cab Service guarantees safe, efficient, and seamless daily travel for the corporate workforce."
  },
  {
    "name": "Magarpatta City Corporate Cab",
    "description": "Magarpatta City Corporate Cab offers premium transportation services for companies, IT firms, and business centers within Magarpatta City. Our service includes dedicated vehicles for executives, daily staff movement, airport transfers, and inter-office travel. All cars are well-maintained, comfortable, and driven by courteous chauffeurs. With flexible rental plans and reliable service standards, Magarpatta City Corporate Cab ensures smooth mobility across the corporate township."
  },
  {
    "name": "SP Infocity Cab Service",
    "description": "SP Infocity Cab Service delivers structured, safe, and convenient transportation for employees and executives working in SP Infocity, Hadapsar. Designed for shift-based operations, we offer verified drivers, GPS-enabled vehicles, and organized pick-up and drop schedules. Cars are equipped with AC, clean interiors, and comfortable seating. SP Infocity Cab Service provides dependable daily office commute solutions for companies of all sizes."
  },
  {
    "name": "Hadapsar Employee Transport",
    "description": "Hadapsar Employee Transport ensures smooth, timely, and safe transportation for corporate employees working in the Hadapsar region. We handle multi-route staff movement, shift-based operations, and night shift pickups with professional safety protocols. Vehicles are sanitized, AC-equipped, and driven by experienced chauffeurs. Hadapsar Employee Transport is ideal for organizations aiming to enhance employee convenience and punctuality."
  },
  {
    "name": "Hadapsar Office Cab Booking",
    "description": "Hadapsar Office Cab Booking provides fast and simple cab reservations for daily office travel, executive commutes, and inter-office meetings. Companies can book sedans, SUVs, and hatchbacks with trained drivers on an on-demand or scheduled basis. With timely pickups, clean vehicles, and flexible plans, Hadapsar Office Cab Booking ensures seamless and stress-free mobility for corporate professionals."
  },
  {
    "name": "Corporate Shuttle Hadapsar",
    "description": "Corporate Shuttle Hadapsar offers large-capacity transportation for teams working in Magarpatta City, SP Infocity, and nearby IT parks. Our shuttles include AC vans, minibuses, and tempo travellers with comfortable seating and fixed-route operations. Designed for large enterprises, we manage timing coordination, multi-route travel, and workforce movement at scale. Corporate Shuttle Hadapsar ensures efficient and economical daily group travel."
  },
  {
    "name": "Staff Pick & Drop Hadapsar",
    "description": "Staff Pick & Drop Hadapsar provides reliable and punctual daily commute services for employees. From early morning to late-night shifts, we ensure safe travel with verified drivers and GPS-enabled vehicles. Our pickup and drop schedules are optimized for minimal delays and maximum comfort. Staff Pick & Drop Hadapsar is suitable for IT companies, corporate offices, and BPOs operating in Hadapsar."
  },
  {
    "name": "Hadapsar Business Travel Cab",
    "description": "Hadapsar Business Travel Cab offers premium cab services for executives, managers, and corporate teams traveling for meetings, conferences, and business visits. Vehicles include comfortable sedans and SUVs equipped with AC, clean interiors, and smooth suspension for long journeys. With disciplined chauffeurs and flexible booking options, Hadapsar Business Travel Cab ensures professional and stress-free business mobility."
  },
  {
    "name": "Best Corporate Taxi Hadapsar",
    "description": "Best Corporate Taxi Hadapsar delivers top-quality, punctual, and well-managed taxi services for companies across the Hadapsar region. Ideal for executive movement, office commute, client visits, and corporate tours, our vehicles are regularly maintained and driven by skilled chauffeurs. Companies benefit from daily rental, monthly contracts, and on-demand cab options. Best Corporate Taxi Hadapsar ensures a trusted and comfortable corporate travel experience."
  },
  {
    "name": "Hadapsar Monthly Cab Hire",
    "description": "Hadapsar Monthly Cab Hire offers long-term transportation solutions with dedicated cabs assigned to your organization. Vehicles come with trained chauffeurs, monthly billing, and priority support. Perfect for executives, field teams, and daily office commuters. With sanitized interiors, AC comfort, and reliable service, Hadapsar Monthly Cab Hire ensures smooth and consistent mobility throughout the month."
  },
  {
    "name": "Corporate Sedan Cabs Hadapsar",
    "description": "Corporate Sedan Cabs Hadapsar offers premium sedan vehicles for executive-level travel. Cars such as Dzire, Etios, Honda City, and Verna provide a smooth, spacious, and comfortable ride for meetings, airport transfers, and business visits. Chauffeurs follow strict professionalism, punctuality, and safety standards. Corporate Sedan Cabs Hadapsar is ideal for organizations seeking comfort and class in their daily corporate travel."
  },
  {
    "name": "Corporate SUV Cab Hadapsar",
    "description": "Corporate SUV Cab Hadapsar provides spacious and high-comfort SUV vehicles perfect for long-distance travel, group movement, and executive trips. SUVs like Ertiga, Innova, and Crysta offer superior comfort, strong AC, and ample luggage space. Chauffeurs trained for corporate travel ensure smooth, safe, and timely service. Corporate SUV Cab Hadapsar is ideal for elevated corporate mobility."
  },
  {
    "name": "Outstation Taxi Hadapsar",
    "description": "Outstation Taxi Hadapsar offers comfortable and safe intercity travel for business meetings, outstation assignments, and corporate trips. Vehicles include sedans and SUVs equipped with AC, clean seating, and strong suspension for long journeys. Our drivers are experienced in highway routes and ensure punctual arrivals. Outstation Taxi Hadapsar is perfect for companies requiring dependable and professional outstation transportation."
  },
  {
    "name": "Corporate Fleet Management Hadapsar",
    "description": "Corporate Fleet Management Hadapsar offers end-to-end vehicle and chauffeur management for companies with large-scale transportation requirements. We provide sedans, SUVs, vans, and tempo travellers with maintenance, replacements, insurance, and driver allocation included. Ideal for IT firms, industrial units, and corporate offices, Corporate Fleet Management Hadapsar ensures seamless, cost-efficient, and centralized mobility solutions."
  },
  {
    "name": "Hadapsar Chauffeur Cars",
    "description": "Hadapsar Chauffeur Cars offers luxury chauffeur-driven sedans and SUVs for executives, VIP clients, and high-level corporate travel. Our chauffeurs are trained in business etiquette, safe driving, and route planning. Vehicles are premium, well-maintained, and comfortable, ensuring a smooth and elegant travel experience. Hadapsar Chauffeur Cars is ideal for important meetings, airport transfers, and premium corporate mobility."
  }
],
"tableData": [
  ["Hadapsar IT Park Cab Service", "Magarpatta City Corporate Cab"],
  ["SP Infocity Cab Service", "Hadapsar Employee Transport"],
  ["Hadapsar Office Cab Booking", "Corporate Shuttle Hadapsar"],
  ["Staff Pick & Drop Hadapsar", "Hadapsar Business Travel Cab"],
  ["Best Corporate Taxi Hadapsar", "Hadapsar Monthly Cab Hire"],
  ["Corporate Sedan Cabs Hadapsar", "Corporate SUV Cab Hadapsar"],
  ["Outstation Taxi Hadapsar", "Corporate Fleet Management Hadapsar"],
  ["Hadapsar Chauffeur Cars", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Hadapsar",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable and premium corporate cab services in Hadapsar, ensuring smooth and efficient travel for employees and business professionals."
  },
  {
    "WhyChooseheading": "Perfect for IT & Industrial Zones",
    "WhyChoosedescription": "Our services are ideal for companies located in Magarpatta, SP Infocity, and Hadapsar Industrial Estate, providing punctual and seamless daily commuting solutions."
  },
  {
    "WhyChooseheading": "Clean, Safe & Comfortable Vehicles",
    "WhyChoosedescription": "All our cabs are well-maintained, sanitized, and designed to deliver a comfortable, safe, and stress-free ride."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Pricing",
    "WhyChoosedescription": "We offer clear pricing with no hidden charges, suitable for both small companies and large corporate travel requirements."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans for Corporates",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly corporate cab packages tailored to align with office timings and employee needs."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure timely pickups, safe driving, and a pleasant experience for every employee and executive."
  },
  {
    "WhyChooseheading": "24/7 Corporate Assistance",
    "WhyChoosedescription": "Our support team is available round-the-clock to help with bookings, schedule modifications, and urgent travel requests."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate cab for Hadapsar easily via phone or our online platform, with fast confirmations and reliable service."
  }
]





















  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited offer corporate cab services in Hadapsar?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides reliable and professional corporate cab services in Hadapsar for office commute, meetings, and business travel.',
  },
  {
    question: 'How can I book a corporate cab in Hadapsar with Pune Corporate Cars India Private Limited?',
    answer: 'You can book easily through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services in Hadapsar?',
    answer: 'We offer hatchbacks, sedans, SUVs, and luxury vehicles to suit various corporate travel needs in Hadapsar.',
  },
  {
    question: 'Are drivers trained for corporate travel in Hadapsar?',
    answer: 'Yes, our drivers are professional, well-trained, punctual, and experienced in handling corporate transportation requirements.',
  },
  {
    question: 'Do you provide daily, weekly, or monthly corporate cab packages in Hadapsar?',
    answer: 'Absolutely. We offer flexible daily, weekly, and monthly corporate cab plans for companies in Hadapsar.',
  },
  {
    question: 'Is the corporate cab service available 24×7 in Hadapsar?',
    answer: 'Yes, Pune Corporate Cars India Private Limited provides round-the-clock availability to meet all corporate travel schedules.',
  },
  {
    question: 'What safety and hygiene measures are followed for corporate cabs in Hadapsar?',
    answer: 'All vehicles are sanitized regularly and drivers follow strict safety and hygiene protocols.',
  },
  {
    question: 'What payment methods are available for corporate cab services in Hadapsar?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate billing options.',
  },
  {
    question: 'Is customer support available during the corporate cab service period?',
    answer: 'Yes, our 24×7 customer support team is available throughout the service duration to assist you anytime.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Pravin Shinde',
    feedback: 'Excellent and reliable corporate cab service in Hadapsar. The car was clean, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Manasi Desai',
    feedback: 'Our company regularly uses Pune Corporate Cars India Private Limited in Hadapsar. They are always on time and extremely dependable.',
    rating: 5,
  },
];










































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Hadapsar",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-hadapsar.jpg", // replace with actual image URL
  "description": "Trusted corporate cab services in Hadapsar, Pune, offering employee transportation, office pickup and drop, IT park shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited provides comfortable and safe rides for Hadapsar offices and corporate clients.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4600", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-hadapsar"
  }
};








  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Hadapsar | Employee & Office Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Trusted corporate cab services in Hadapsar, Pune, offering employee transportation, office pickup and drop, IT park shuttle services, and business travel cabs. Pune Corporate Cars India Private Limited ensures safe and comfortable rides for Hadapsar offices and corporate clients."
  />

  <meta
    name="keywords"
    content="Hadapsar IT Park Cab Service, Magarpatta City Corporate Cab, SP Infocity Cab Service, Hadapsar Employee Transport, Hadapsar Office Cab Booking, Corporate Shuttle Hadapsar, Staff Pick & Drop Hadapsar, Hadapsar Business Travel Cab, Best Corporate Taxi Hadapsar, Hadapsar Monthly Cab Hire, Corporate Sedan Cabs Hadapsar, Corporate SUV Cab Hadapsar, Outstation Taxi Hadapsar, Corporate Fleet Management Hadapsar, Hadapsar Chauffeur Cars"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/7.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhadapsar;